import { BaseService } from "./BaseService";
import {
  SendExternalChatMessageRequest,
  SendExternalChatMessageResponse,
} from "@/types/chat-external-message";

class ChatExternalMessageService extends BaseService {
  private basePath = "/chat/messages/external";

  send(
    payload: SendExternalChatMessageRequest,
  ): Promise<SendExternalChatMessageResponse> {
    return this.post<SendExternalChatMessageResponse>(this.basePath, payload);
  }
}

export const chatExternalMessageService = new ChatExternalMessageService();
